import { DataBox } from './DataBox'
import { PageHeader } from './PageHeader'

export function ThreeInspectionAlcoholDriving() {
    return (
        <>
            <PageHeader />
            <DataBox />
        </>
    )
}
